export default __webpack_public_path__ + "static/media/DP.38bca87b.webp";